import React, { Component } from 'react';
import { Grid, Card } from '@material-ui/core';
import { Row, Col, Typography, Upload, notification, Icon } from 'antd';
import MainContainer from '../../../components/MainContainer';
import ApiCaller from '../../../utils/api-caller';

import '../ImportItemLanguage/importItemLanguage.css';

const { Text } = Typography;

class ImportChatIntentPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadingFileState: false
        }
    }

    componentDidMount() {
    }

    // ON UPLOAD

    dummyFileUploadRequest = ({ file, onSuccess }) => {
        setTimeout(() => { onSuccess('ok') }, 0);
    }

    beforeUploadFile = (file) => {
        const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        if (!isExcel) {
            notification.warning({
                message: `Failed to upload file`,
                description: 'You can only upload Excel file!',
                placement: 'bottomRight',
            });
        }

        const isLessThan10Mb = file.size / 1024 / 1024 < 2;
        if (!isLessThan10Mb) {
            notification.warning({
                message: `Failed to upload image`,
                description: 'File must smaller than 10MB!',
                placement: 'bottomRight',
            });
        }

        if (isExcel && isLessThan10Mb) {
            this.setState({ uploadingFileState: true });
        }

        return isExcel && isLessThan10Mb;
    }

    uploadFileOnChange = (info) => {
        if (info.file.status) {
            if (info.file.status === 'uploading') { return; }

            if (info.file.status === 'done') {
                ApiCaller.ChatIntent.Import(info.file.originFileObj).then(response => {
                    if (response) {
                        const element = document.createElement("a");
                        const file = new Blob([response.text], { type: "text/plain" });
                        element.href = URL.createObjectURL(file);
                        element.download = "rhasspy-intents.txt";

                        document.body.appendChild(element);
                        element.click();

                        notification.success({
                            message: `Success`,
                            description: 'Chat intents import has been executed. Please check the files downloaded and ensure its correct. Once correct, please copy and paste the content to the rhasspy.',
                            placement: 'topRight',
                            duration: 20
                        });
                    } else {
                        notification.error({
                            message: `Error`,
                            description: `Failed to import chat intents. Please contact your administrator.`,
                            placement: 'topRight',
                        });
                    }
                    this.setState({ uploadingFileState: false });
                })
            }
        }
    }

    render() {
        const uploadFileButton = (
            <div>
                {
                    this.state.uploadingFileState
                        ?
                        <React.Fragment>
                            <Icon className='importItemLanguage-icon-upload' type='loading' />
                            <div className='importItemLanguage-div-upload'>Importing Chat Intents ...</div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <Icon className='importItemLanguage-icon-upload' type='plus' />
                            <div className='importItemLanguage-div-upload'>Import Chat Intents</div>
                        </React.Fragment>
                }
            </div>
        );

        return (
            <MainContainer title='Chat Intents Import' menukey='chatintentimport'>
                <Grid container spacing={2} style={{ marginBottom: 20 }}>
                    <Grid item xs={12}>
                        <Card>
                            <Row className='importItemLanguage-row-container'>
                                <Col span={24} className='importItemLanguage-col-label'>
                                    <Text className='importItemLanguage-text-label'>Import Chat Intents</Text><br />
                                    <Text className='importItemLanguage-text-label-detail'>Your file must be an excel</Text>
                                </Col>
                                <Col span={24} className='importItemLanguage-col-input'>
                                    <Upload
                                        listType='picture-card'
                                        className='avatar-uploader'
                                        showUploadList={false}
                                        customRequest={this.dummyFileUploadRequest}
                                        beforeUpload={this.beforeUploadFile}
                                        onChange={(info) => this.uploadFileOnChange(info)}
                                    >
                                        {uploadFileButton}
                                    </Upload>
                                </Col>
                            </Row>
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default ImportChatIntentPage;